export const iconFontAwesomeHandsHandPointLeft = (
	<i className="fa-solid fa-hand-point-left"></i>
);
